import { GetInitialDataCtx, WidgetProps } from "../../contracts/widget"
import { GalleryWidgetConfig, parseGalleryConfig } from "./config"
import { WidgetProvider } from "../../providers/widget"
import { GalleryProvider } from "./providers"
import { GalleryAppContent } from "./components/GalleryWidgetContent"
import "./gallery.css"
import { useMemo } from "react"

export const getInitialData = async ({ options, feedId, widgetId }: GetInitialDataCtx<GalleryWidgetConfig>) => {
    return {
        demo: 'nemo'
    }
}

export default function GalleryWidget({ options, feedId, widgetId, resolvedTheme, data }: WidgetProps<GalleryWidgetConfig>) {
    const parsedOptions = useMemo(() => parseGalleryConfig(options), [options])
    return (
        <WidgetProvider options={parsedOptions} feedId={feedId} widgetId={widgetId} resolvedTheme={resolvedTheme} widgetType="gallery" data={data??{}}>
            <GalleryProvider>
                <GalleryAppContent />
            </GalleryProvider>
        </WidgetProvider>
    )
}
